import { render, staticRenderFns } from "./MyFavorites.vue?vue&type=template&id=8cc94a52&scoped=true"
import script from "./MyFavorites.vue?vue&type=script&lang=ts"
export * from "./MyFavorites.vue?vue&type=script&lang=ts"
import style0 from "./MyFavorites.vue?vue&type=style&index=0&id=8cc94a52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc94a52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cc94a52')) {
      api.createRecord('8cc94a52', component.options)
    } else {
      api.reload('8cc94a52', component.options)
    }
    module.hot.accept("./MyFavorites.vue?vue&type=template&id=8cc94a52&scoped=true", function () {
      api.rerender('8cc94a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companyContractors/MyFavorites.vue"
export default component.exports